module.exports = __webpack_public_path__ + "static/media/google-play-badge.9468c3f2.svg";